import { render, staticRenderFns } from "./newTransportationInvoice.vue?vue&type=template&id=0790e343&"
import script from "./newTransportationInvoice.vue?vue&type=script&lang=js&"
export * from "./newTransportationInvoice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports